(function () {
  if (typeof window === 'undefined' || window.__FIRST_PARTY_CART_ADD__) return;

  var REQUEST_EVENT = 'cart:add-request';
  var RESULT_EVENT = 'cart:add-result';
  var RESULT_TIMEOUT_MS = 10000;

  function toPositiveInt(value, fallbackValue) {
    var parsed = Number(value);
    if (!Number.isFinite(parsed) || parsed <= 0) {
      return fallbackValue;
    }
    return Math.floor(parsed);
  }

  function parseProperties(formData) {
    var properties = {};
    var hasProperties = false;

    formData.forEach(function (value, key) {
      var match = /^properties\[(.+)\]$/.exec(key);
      if (!match || typeof value !== 'string') return;
      properties[match[1]] = value;
      hasProperties = true;
    });

    return hasProperties ? properties : undefined;
  }

  function buildSingleItemPayload(formData) {
    var id = toPositiveInt(formData.get('id'), null);
    if (!id) return [];

    var quantity = toPositiveInt(formData.get('quantity'), 1);
    var item = {
      id: id,
      quantity: quantity,
    };
    var properties = parseProperties(formData);
    var sellingPlan = toPositiveInt(formData.get('selling_plan'), null);

    if (properties) {
      item.properties = properties;
    }
    if (sellingPlan) {
      item.selling_plan = sellingPlan;
    }

    return [item];
  }

  function buildBatchItemsPayload(formData) {
    var ids = formData.getAll('items[][id]');
    if (!ids.length) return [];

    var quantities = formData.getAll('items[][quantity]');
    var items = [];

    ids.forEach(function (rawId, index) {
      var id = toPositiveInt(rawId, null);
      var quantity = toPositiveInt(quantities[index], 1);
      if (!id || !quantity) return;
      items.push({
        id: id,
        quantity: quantity,
      });
    });

    return items;
  }

  function productGid(value) {
    var id = toPositiveInt(value, null);
    return id ? 'gid://shopify/Product/' + id : null;
  }

  // Internal command lines: the business identity (productId + variantId) of each transport item. The Shopify
  // transport items stay exactly the /cart/add shape; productId never enters them.
  function buildCommandLines(form, formData, items, batch) {
    var batchFields = batch ? form.querySelectorAll('[name="items[][id]"]') : [];
    var formProduct = productGid(formData.get('product-id'))
      || productGid(form.dataset && form.dataset.productId)
      || productGid(form.closest && form.closest('[data-product-id]') && form.closest('[data-product-id]').dataset.productId);
    return items.map(function (item) {
      var productId = formProduct;
      if (batch) {
        productId = null;
        Array.prototype.forEach.call(batchFields, function (field) {
          if (!productId && toPositiveInt(field.value, null) === item.id) productId = productGid(field.dataset.productId);
        });
      }
      return { productId: productId, variantId: 'gid://shopify/ProductVariant/' + item.id, quantity: item.quantity };
    });
  }

  function normalizeCartAddForm(form) {
    var formData = new FormData(form);
    var batchItems = buildBatchItemsPayload(formData);
    var items = batchItems.length > 0 ? batchItems : buildSingleItemPayload(formData);
    return {
      formData: formData,
      items: items,
      commandLines: buildCommandLines(form, formData, items, batchItems.length > 0),
    };
  }

  function ensureBridgeReady(source) {
    if (document.documentElement.dataset.tvCartCapabilityReady === 'true') {
      return Promise.resolve(true);
    }
    if (!window.tvInteractions) {
      return Promise.resolve(false);
    }

    window.tvInteractions.preload({ kind: 'cart', source: source || 'theme-add' });
    return new Promise(function (resolve) {
      var settled = false;
      var finish = function (ready) {
        if (settled) return;
        settled = true;
        window.removeEventListener('tv:cart-capability-ready', onReady);
        window.clearTimeout(timeoutId);
        resolve(ready);
      };
      var onReady = function () { finish(true); };
      var timeoutId = window.setTimeout(function () { finish(false); }, 1500);
      window.addEventListener('tv:cart-capability-ready', onReady, { once: true });
    });
  }

  function buildRequestId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
    return 'cart-add-' + Date.now() + '-' + Math.random().toString(16).slice(2);
  }

  function waitForAddResult(requestId) {
    return new Promise(function (resolve) {
      var timeoutId = null;
      var handleResult = function (event) {
        var detail = event && event.detail;
        if (!detail || detail.requestId !== requestId) return;
        window.removeEventListener(RESULT_EVENT, handleResult);
        if (timeoutId) {
          window.clearTimeout(timeoutId);
        }
        resolve(detail);
      };

      timeoutId = window.setTimeout(function () {
        window.removeEventListener(RESULT_EVENT, handleResult);
        resolve({
          requestId: requestId,
          ok: false,
          errorCode: 'BRIDGE_TIMEOUT',
          errorMessage: (window.cartStrings && window.cartStrings.error) || 'Cart error',
        });
      }, RESULT_TIMEOUT_MS);

      window.addEventListener(RESULT_EVENT, handleResult);
    });
  }

  // Source lifetime begins before any asynchronous readiness check or Cart write.
  function captureOrigin(form, requestId) {
    var host = form.closest('quick-add-modal, modal-dialog, dialog, [role="dialog"]') || form;
    var hadOpen = host.hasAttribute('open');
    var origin = { originId: requestId, sessionId: buildRequestId(), revision: 1, revoked: false };
    var disposed = false;
    function revoke() {
      if (origin.revoked) return;
      origin.revoked = true;
      window.dispatchEvent(new CustomEvent('cart:add-origin-revoked', { detail: { originId: origin.originId } }));
      dispose();
    }
    function checkSource() {
      if (!host.isConnected || !form.isConnected || host.hidden || host.getAttribute('aria-hidden') === 'true'
        || (hadOpen && !host.hasAttribute('open')) || window.getComputedStyle(host).display === 'none') revoke();
    }
    var observer = new MutationObserver(checkSource);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    observer.observe(host, { attributes: true, attributeFilter: ['open', 'hidden', 'aria-hidden', 'class', 'style'] });
    function onSettled(event) { if (event.detail && event.detail.requestId === requestId) dispose(); }
    function dispose() {
      if (disposed) return;
      disposed = true;
      observer.disconnect();
      window.clearTimeout(expiry);
      window.removeEventListener('pagehide', revoke);
      window.removeEventListener('cart:add-feedback-settled', onSettled);
      document.body.removeEventListener('modalClosed', checkSource);
    }
    // This bounds only notification admission. It never retries or cancels a Cart write.
    var expiry = window.setTimeout(revoke, 60000);
    window.addEventListener('pagehide', revoke, { once: true });
    window.addEventListener('cart:add-feedback-settled', onSettled);
    document.body.addEventListener('modalClosed', checkSource);
    checkSource();
    return { snapshot: function () { return Object.assign({}, origin); }, revoke: revoke, dispose: dispose };
  }

  function cartErrorText() {
    return (window.cartStrings && window.cartStrings.error) || 'Cart error';
  }

  // Native Shopify add. Used ONLY when the request was never handed to the App bridge, so there is no
  // possibility of a second write. The App (when present later) refreshes from the server; the theme badge
  // is updated from the confirmed /cart.js snapshot.
  async function nativeAdd(normalized, source) {
    var routes = window.routes || {};
    var headers = { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' };
    var response;
    var payload = null;
    try {
      response = await fetch(routes.cart_add_url || '/cart/add', { method: 'POST', headers: headers,
        body: normalized.formData, credentials: 'same-origin' });
      try { payload = await response.json(); } catch (parseError) { payload = null; }
    } catch (error) {
      return { ok: false, transport: 'native', errorCode: 'NATIVE_ADD_NETWORK', errorMessage: cartErrorText() };
    }
    if (!response.ok || (payload && payload.status)) {
      return { ok: false, transport: 'native', errorCode: 'NATIVE_ADD_REJECTED', statusCode: (payload && payload.status) || response.status,
        errorMessage: (payload && (payload.description || payload.message)) || cartErrorText() };
    }
    var cart = null;
    try {
      var cartResponse = await fetch((routes.cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' },
        credentials: 'same-origin' });
      if (cartResponse.ok) cart = await cartResponse.json();
    } catch (cartError) { cart = null; }
    if (cart && typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
      window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: source, cartData: cart });
    }
    return { ok: true, transport: 'native', payload: payload, cart: cart };
  }

  // Local confirmation for a native add: the App bridge was not ready, so neither the after-add panel nor the cart
  // drawer is available. The add is confirmed in place; the page stays where it is and no cart opens.
  var TOAST_ID = 'tv-native-add-toast';
  var TOAST_MS = 2600;
  var toastTimer = null;

  function ensureToastStyles() {
    if (document.getElementById(TOAST_ID + '-style')) return;
    var style = document.createElement('style');
    style.id = TOAST_ID + '-style';
    style.textContent = '.tv-native-add-toast{position:fixed;left:50%;bottom:24px;z-index:2147483000;display:flex;'
      + 'align-items:center;gap:8px;max-width:calc(100vw - 32px);padding:12px 18px;border-radius:var(--tv-radius-pill,999px);'
      + 'background:var(--tv-color-ink-900,#1f2937);color:var(--tv-color-white,#fff);font-family:var(--tv-font-family-sans,inherit);'
      + 'font-size:var(--tv-font-size-sm,.875rem);font-weight:600;line-height:1.3;box-shadow:var(--tv-shadow-md,0 8px 24px rgba(17,24,39,.18));'
      + 'opacity:0;transform:translate(-50%,8px);transition:opacity .2s ease,transform .2s ease;pointer-events:none}'
      + '.tv-native-add-toast.is-active{opacity:1;transform:translate(-50%,0)}'
      + '.tv-native-add-toast__icon{color:var(--tv-color-success-500,#20b84f);font-size:1.1em}'
      + '@media (prefers-reduced-motion:reduce){.tv-native-add-toast{transition:none}}';
    document.head.appendChild(style);
  }

  function showAddedToast() {
    ensureToastStyles();
    var toast = document.getElementById(TOAST_ID);
    if (!toast) {
      toast = document.createElement('div');
      toast.id = TOAST_ID;
      toast.className = 'tv-native-add-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      var icon = document.createElement('span');
      icon.className = 'tv-native-add-toast__icon';
      icon.setAttribute('aria-hidden', 'true');
      icon.textContent = '\u2713';
      var label = document.createElement('span');
      label.className = 'tv-native-add-toast__label';
      toast.appendChild(icon);
      toast.appendChild(label);
      document.body.appendChild(toast);
    }
    toast.querySelector('.tv-native-add-toast__label').textContent =
      (window.cartStrings && window.cartStrings.addedToCart) || 'Aggiunto al carrello';
    // Restart the announcement for a repeated add.
    toast.classList.remove('is-active');
    void toast.offsetWidth;
    toast.classList.add('is-active');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () { toast.classList.remove('is-active'); }, TOAST_MS);
  }

  /**
   * Shared success feedback for the native path (the App bridge was not ready): a local "added to cart"
   * confirmation. It never opens the cart or leaves the page; the theme badge already follows the
   * confirmed /cart.js snapshot published by nativeAdd.
   */
  function presentNativeSuccess() {
    showAddedToast();
  }

  async function request(params) {
    var normalized = normalizeCartAddForm(params.form);
    if (!normalized.items.length) return { ok: false, transport: 'react', errorCode: 'INVALID_ADD_REQUEST',
      errorMessage: (window.cartStrings && window.cartStrings.error) || 'Cart error' };

    var requestId = buildRequestId();
    var origin = captureOrigin(params.form, requestId);
    try {
      if (!(await ensureBridgeReady(params.source))) {
        // Nothing was dispatched to the App: the native Cart write is the single write for this ADD.
        origin.dispose();
        return Object.assign({ requestId: requestId }, await nativeAdd(normalized, params.source));
      }
      var resultPromise = waitForAddResult(requestId);
      window.dispatchEvent(new CustomEvent(REQUEST_EVENT, { detail: {
        requestId: requestId, items: normalized.items, commandLines: normalized.commandLines, source: params.source,
        origin: origin.snapshot()
      } }));
      var result = await resultPromise;
      if (!result.ok) origin.revoke();
      return Object.assign({ transport: 'react' }, result);
    } catch (error) { origin.revoke(); throw error; }
  }

  window.__FIRST_PARTY_CART_ADD__ = {
    normalizeCartAddForm: normalizeCartAddForm,
    request: request,
    presentNativeSuccess: presentNativeSuccess,
    // An unanswered bridge command may already have written. Never suggest a blind retry.
    reportUnconfirmed: function (result) {
      if (!result || result.ok || (result.errorCode !== 'CART_COMMIT_UNCONFIRMED'
        && result.errorCode !== 'BRIDGE_TIMEOUT')) return false;
      window.dispatchEvent(new CustomEvent('cart:toast', { detail: {
        type: 'info', code: 'CART_COMMIT_UNCONFIRMED'
      } }));
      return true;
    },
  };
})();
